import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProjectsCategoriesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-projects-categories-edit',
	path: '/secure/admin/projectcategories/EditProjectCategory([!%]?[\\w]*).jspa',
};
